import React from "react";
import * as dayjs from "dayjs";
import IntlMessages, { IntlGetText } from "util/IntlMessages";
import { Button } from "@material-ui/core";
import MUIDataTable from "mui-datatables";
import CardBox from "components/CardBox/index";
import { ClinicalFindingTypeList, ClinicalFindingStateList } from "constants/Enums";

const TableAM = ({
  data,
  handleOpenCRU,
  handleOpenDlgAdd,
  setCurrentRowObj,
  currentImpact,
  readOnly
}) => {
  const clinicalFindingTypeList = ClinicalFindingTypeList();
  const clinicalFindingStateList = ClinicalFindingStateList();
  const textYes = IntlGetText("core.yes");
  const textNo = IntlGetText("button.no");

  const datatableConfig = {
    textLabels: {
      body: {
        noMatch: "No hay resultados para la búsqueda actual",
        toolTip: "Ordenar",
        columnHeaderTooltip: (column) => `Ordernar por ${column.label}`,
      },
      pagination: {
        next: "Siguiente",
        previous: "Anterior",
        rowsPerPage: "Items por pagina:",
        displayRows: "de",
      },
      toolbar: {
        search: "Busqueda",
        downloadCsv: "Descargar CSV",
        print: "Imprimir",
        viewColumns: "Ver columnas",
        filterTable: "Filtro",
      },
      filter: {
        all: "Todos",
        title: "FILTRO",
        reset: "LIMPIAR",
      },
      viewColumns: {
        title: "Mostrar columnas",
        titleAria: "Mostrar/Ocultar columnas",
      },
      selectedRows: {
        text: "item(s) seleccionados",
        delete: "Borrar",
        deleteAria: "Borrar filas seleccionadas",
      },
    },
  };

  const options = {
    filter: false,
    filterType: "dropdown",
    download: false,
    print: false,
    viewColumns: false,
    selectableRows: "none",
    search: false,
    textLabels: datatableConfig.textLabels,
  };

  const handleClick = (obj) => {
    handleOpenCRU();
    setCurrentRowObj(
      !obj ? null : obj
    );
  };
  const handleClickAdd = () => {
    handleOpenDlgAdd();
    setCurrentRowObj(null);
  };
  const getRowObj = (tableMeta) => tableMeta.tableData[tableMeta.rowIndex];

  const columns = [
    {
      name: "type",
      label: IntlGetText("core.type"),
      options: {
        filter: false,
        sort: false,
        customBodyRender: (value, tableMeta, updateValue) => {
          var type = clinicalFindingTypeList.find(x=>x.id === value);
          return !type ? "" : type.name;
        },
      },
    },
    {
      name: "adverseEvent",
      label: IntlGetText("core.adverseEvent"),
      options: {
        filter: false,
        sort: false,
        customBodyRender: (value, tableMeta, updateValue) => {
          return value ? textYes : textNo;
        },
      },
    },
    {
      name: "state",
      label: IntlGetText("core.state"),
      options: {
        filter: false,
        sort: false,
        customBodyRender: (value, tableMeta, updateValue) => {
          var state = clinicalFindingStateList.find(x=>x.id === value);
          return !state ? "" : state.name;
        },
      },
    },
    {
      name: "startDate",
      label: IntlGetText("clinicalFinding.startDate"),
      options: {
        filter: false,
        sort: false,
        customBodyRender: (value, tableMeta, updateValue) => {
          return value ? dayjs(value).format("YYYY/MM/DD") : "";
        },
      },
    },
    {
      name: "endDate",
      label: IntlGetText("clinicalFinding.endDate"),
      options: {
        filter: false,
        sort: false,
        customBodyRender: (value, tableMeta, updateValue) => {
          return value ? dayjs(value).format("YYYY/MM/DD") : "";
        },
      },
    },
    {
      name: "comment",
      label: IntlGetText("core.description"),
      options: {
        filter: false,
        sort: false,
        customBodyRender: (value, tableMeta, updateValue) => {
          return value;
        },
      },
    },
    {
      name: "actions",
      label: IntlGetText("core.actions"),
      options: {
        filter: false,
        sort: false,
        customBodyRender: (value, tableMeta, updateValue) => {         
          var rowObj = getRowObj(tableMeta);
          if (rowObj.impactId != currentImpact || readOnly) {
            return (
              <div>
                <Button
                  onClick={() => handleClick(rowObj)}
                  variant="contained"
                  className="jr-btn jr-btn-xs"
                >
                  <i className="zmdi zmdi-eye"></i>
                </Button>
              </div>
            );
          }

          return (
            <div>
              <Button
                onClick={() => handleClick(rowObj)}
                variant="contained"
                className="jr-btn jr-btn-xs"
              >
                <i className="zmdi zmdi-edit"></i>
              </Button>
            </div>
          );
        },
      },
    },
  ];

  return (
    <div className="row">
      <CardBox styleName="col-12" cardStyle="p-0 border-dialog-card">
        <MUIDataTable
          className="border-dialog-card"
          data={data}
          columns={columns}
          options={options}
        />
      </CardBox>
      {!readOnly && (
        <div className="col-lg-12 col-md-12 col-xs-12 mt-4 text-center">
          <Button
            onClick={() => handleClickAdd()}
            variant="contained"
            color="primary"
          >
            {<IntlMessages id="core.add" />}
          </Button>
        </div>
      )}
    </div>
  );
};

export default TableAM;
